import { render, staticRenderFns } from "./Step-1.vue?vue&type=template&id=bc98d6a6&scoped=true&"
import script from "./Step-1.vue?vue&type=script&lang=js&"
export * from "./Step-1.vue?vue&type=script&lang=js&"
import style0 from "./Step-1.vue?vue&type=style&index=0&id=bc98d6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc98d6a6",
  null
  
)

export default component.exports